import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LifeEventCompletedState {
  lifeEventCompleted: string;
}

const initialState: LifeEventCompletedState = {
  lifeEventCompleted: '',
};

const lifeEventCompletedSlice = createSlice({
  name: 'lifeEventCompleted',
  initialState,
  reducers: {
    setLifeEventCompleted: (state, { payload }: PayloadAction<string>) => {
      state.lifeEventCompleted = payload;
      localStorage.setItem('lifeEventCompleted', payload);
    },
  },
});

const { reducer, actions } = lifeEventCompletedSlice;

export const { setLifeEventCompleted } = actions;

export const lifeEventCompletedReducer = reducer;
